import {memo} from "react";
import {ExclamationTriangleIcon} from "@heroicons/react/20/solid";
import {Tag} from "../../../../components/ui/tag";

// Column-header pill flagging that at least one upstream row in this column
// has a verdict at or below the unfavourable threshold — i.e. reliance on
// this dependent control is at risk and needs auditor attention.
const ImpactedBadge = memo(() => (
  <Tag colorPalette="red" variant="subtle" size="sm" startElement={<ExclamationTriangleIcon width={12} height={12} />}>
    Impacted
  </Tag>
));

export default ImpactedBadge;
